export default "__VITE_ASSET__rFF0B9A3__"